{
  "asyncapi": "3.1.0",
  "info": {
    "title": "Springwolf example project - Cloud Stream",
    "version": "1.0.0",
    "description": "Springwolf [example project](https://github.com/springwolf/springwolf-core/tree/main/springwolf-examples/springwolf-cloud-stream-example) to demonstrate springwolfs abilities, including **markdown** support for descriptions.",
    "termsOfService": "https://asyncapi.org/terms",
    "contact": {
      "name": "springwolf",
      "url": "https://github.com/springwolf/springwolf-core",
      "email": "example@example.com"
    },
    "license": {
      "name": "Apache License 2.0"
    },
    "x-generator": "springwolf"
  },
  "defaultContentType": "application/json",
  "servers": {
    "kafka-server": {
      "host": "kafka:29092",
      "protocol": "kafka"
    }
  },
  "channels": {
    "another-topic": {
      "address": "another-topic",
      "messages": {
        "AnotherPayloadDto": {
          "$ref": "#/components/messages/AnotherPayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "biconsumer-topic": {
      "address": "biconsumer-topic",
      "messages": {
        "AnotherPayloadDto": {
          "$ref": "#/components/messages/AnotherPayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "bifunction-output-topic": {
      "address": "bifunction-output-topic",
      "messages": {
        "AnotherPayloadDto": {
          "$ref": "#/components/messages/AnotherPayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "bifunction-topic": {
      "address": "bifunction-topic",
      "messages": {
        "ExamplePayloadDto": {
          "$ref": "#/components/messages/ExamplePayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "consumer-class-topic": {
      "address": "consumer-class-topic",
      "messages": {
        "ExamplePayloadDto": {
          "$ref": "#/components/messages/ExamplePayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "consumer-topic": {
      "address": "consumer-topic",
      "messages": {
        "AnotherPayloadDto": {
          "$ref": "#/components/messages/AnotherPayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "example-topic": {
      "address": "example-topic",
      "messages": {
        "ExamplePayloadDto": {
          "$ref": "#/components/messages/ExamplePayloadDto"
        }
      },
      "bindings": {
        "kafka": { }
      }
    },
    "google-pubsub-topic": {
      "address": "google-pubsub-topic",
      "messages": {
        "GooglePubSubPayloadDto": {
          "$ref": "#/components/messages/GooglePubSubPayloadDto"
        }
      },
      "bindings": {
        "googlepubsub": {
          "messageStoragePolicy": { },
          "schemaSettings": {
            "encoding": "BINARY",
            "name": "project/test"
          },
          "bindingVersion": "0.2.0"
        }
      }
    }
  },
  "components": {
    "schemas": {
      "AnotherPayloadDto": {
        "title": "AnotherPayloadDto",
        "type": "object",
        "properties": {
          "example": {
            "$ref": "#/components/schemas/ExamplePayloadDto"
          },
          "foo": {
            "type": "string",
            "description": "Foo field",
            "maxLength": 100,
            "examples": [
              "bar"
            ]
          }
        },
        "description": "Another payload model",
        "examples": [
          {
            "example": {
              "someEnum": "FOO2",
              "someLong": 5,
              "someString": "some string value"
            },
            "foo": "bar"
          }
        ],
        "required": [
          "example"
        ]
      },
      "ExamplePayloadDto": {
        "title": "ExamplePayloadDto",
        "type": "object",
        "properties": {
          "someEnum": {
            "title": "ExampleEnum",
            "type": "string",
            "description": "Some enum field",
            "enum": [
              "FOO1",
              "FOO2",
              "FOO3"
            ],
            "examples": [
              "FOO2"
            ]
          },
          "someLong": {
            "type": "integer",
            "description": "Some long field",
            "format": "int64",
            "minimum": 0,
            "examples": [
              5
            ]
          },
          "someString": {
            "type": "string",
            "description": "Some string field",
            "examples": [
              "some string value"
            ]
          }
        },
        "description": "Example payload model",
        "examples": [
          {
            "someEnum": "FOO2",
            "someLong": 5,
            "someString": "some string value"
          }
        ],
        "required": [
          "someEnum",
          "someString"
        ]
      },
      "GooglePubSubPayloadDto": {
        "title": "GooglePubSubPayloadDto",
        "type": "object",
        "properties": {
          "someLong": {
            "type": "integer",
            "description": "Some long field",
            "format": "int64",
            "minimum": 0,
            "examples": [
              5
            ]
          },
          "someString": {
            "type": "string",
            "description": "Some string field",
            "examples": [
              "some string value"
            ]
          }
        },
        "description": "Google pubsub payload model",
        "examples": [
          {
            "someLong": 5,
            "someString": "some string value"
          }
        ],
        "required": [
          "someString"
        ]
      },
      "HeadersNotDocumented": {
        "title": "HeadersNotDocumented",
        "type": "object",
        "properties": { },
        "description": "There can be headers, but they are not explicitly documented.",
        "examples": [
          { }
        ]
      }
    },
    "messages": {
      "AnotherPayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/AnotherPayloadDto"
          }
        },
        "name": "AnotherPayloadDto",
        "title": "AnotherPayloadDto",
        "bindings": {
          "kafka": { }
        }
      },
      "ExamplePayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/ExamplePayloadDto"
          }
        },
        "name": "ExamplePayloadDto",
        "title": "ExamplePayloadDto",
        "bindings": {
          "kafka": { }
        }
      },
      "GooglePubSubPayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/GooglePubSubPayloadDto"
          }
        },
        "name": "GooglePubSubPayloadDto",
        "title": "GooglePubSubPayloadDto",
        "bindings": {
          "googlepubsub": {
            "schema": {
              "name": "project/test"
            },
            "bindingVersion": "0.2.0"
          }
        }
      }
    }
  },
  "operations": {
    "another-topic_send_process": {
      "action": "send",
      "channel": {
        "$ref": "#/channels/another-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/another-topic/messages/AnotherPayloadDto"
        }
      ]
    },
    "biconsumer-topic_receive_biConsumerMethod": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/biconsumer-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/biconsumer-topic/messages/AnotherPayloadDto"
        }
      ]
    },
    "bifunction-output-topic_send_biProcess": {
      "action": "send",
      "channel": {
        "$ref": "#/channels/bifunction-output-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/bifunction-output-topic/messages/AnotherPayloadDto"
        }
      ]
    },
    "bifunction-topic_receive_biProcess": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/bifunction-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/bifunction-topic/messages/ExamplePayloadDto"
        }
      ]
    },
    "consumer-class-topic_receive_ConsumerClass": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/consumer-class-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/consumer-class-topic/messages/ExamplePayloadDto"
        }
      ]
    },
    "consumer-topic_receive_consumerMethod": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/consumer-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/consumer-topic/messages/AnotherPayloadDto"
        }
      ]
    },
    "example-topic_receive_process": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/example-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/example-topic/messages/ExamplePayloadDto"
        }
      ]
    },
    "google-pubsub-topic_receive_googlePubSubConsumerMethod": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/google-pubsub-topic"
      },
      "description": "Auto-generated description",
      "bindings": {
        "kafka": { }
      },
      "messages": [
        {
          "$ref": "#/channels/google-pubsub-topic/messages/GooglePubSubPayloadDto"
        }
      ]
    }
  }
}